/**
 * URLs de API según entorno de despliegue.
 * - Local (npm start): localhost
 * - Build CI rama develop → REACT_APP_ENV=staging → API de test
 * - Build CI rama main → REACT_APP_ENV=production → API de producción
 *
 * Build local de producción: REACT_APP_ENV=production npm run build
 */
export const apiVersion = 'v1';

const API_LOCAL = 'http://localhost:8080/api';
const API_STAGING = 'https://test-ampina-dot-bs-proyecto1.rj.r.appspot.com/api';
const API_PRODUCTION = 'https://ampina-dot-bs-proyecto1.rj.r.appspot.com/api';

const PROXY_LOCAL = 'http://localhost:8081/api';
const PROXY_STAGING =
  'https://portal-proxy-staging-293291450389.southamerica-east1.run.app/api';
const PROXY_PRODUCTION =
  'https://portal-proxy-293291450389.southamerica-east1.run.app/api';

function resolveBasePath() {
  if (process.env.NODE_ENV !== 'production') {
    return API_LOCAL;
  }

  const deployEnv = process.env.REACT_APP_ENV;
  if (deployEnv === 'production') {
    return API_PRODUCTION;
  }

  // staging (develop en CI) o build sin REACT_APP_ENV → test
  return API_STAGING;
}

function resolveProxyPath() {
  if (process.env.REACT_APP_PROXY_URL) {
    return process.env.REACT_APP_PROXY_URL.replace(/\/$/, '');
  }

  if (process.env.NODE_ENV !== 'production') {
    return PROXY_LOCAL;
  }

  if (process.env.REACT_APP_ENV === 'production') {
    return PROXY_PRODUCTION;
  }

  return PROXY_STAGING;
}

export let basePath = resolveBasePath();
export let proxyPath = resolveProxyPath();

/** Health del proxy vive en el origen, no bajo `/api`. */
export function getProxyHealthUrl() {
  return `${String(proxyPath).replace(/\/api\/?$/, '')}/health`;
}

if (process.env.NODE_ENV !== 'production') {
  console.log('Desarrollo — API:', basePath, '| Proxy:', proxyPath);
}
